import { createAction } from '@reduxjs/toolkit';
import { ReportErrorActionPayload } from './types';

const reportError = createAction<ReportErrorActionPayload>('errors/reportError');

export {
  reportError,
};
